import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-produkte_statistik",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "show-in-print" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "Datum: ", -1)
const _hoisted_6 = {
  key: 0,
  class: "d-flex justify-content-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_back = _resolveComponent("link-back")!
  const _component_control_date = _resolveComponent("control-date")!
  const _component_button_print = _resolveComponent("button-print")!
  const _component_result_list_tickets_daily = _resolveComponent("result-list-tickets-daily")!
  const _component_feedback_message = _resolveComponent("feedback-message")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", _hoisted_1, [
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_ctx.$t('views.dailyReport.title')), 1)
    ]),
    _createVNode(_component_link_back, {
      to: '/reports',
      i18nMessage: "common.backToOverview"
    }),
    _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.room.name), 1),
    _createVNode(_component_control_date, {
      i18nLabel: "views.dailyReport.date",
      modelValue: _ctx.date,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
        _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadFromServer()))
      ],
      validation: _ctx.v$.date,
      class: "hide-in-print"
    }, null, 8, ["modelValue", "validation"]),
    _createVNode(_component_loading_container, {
      state: _ctx.state,
      errorLinkTo: "/reports"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_ctx.niceDate(_ctx.date)), 1)
        ]),
        (_ctx.tickets.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_button_print)
            ]))
          : _createCommentVNode("", true),
        (_ctx.tickets.length > 0)
          ? (_openBlock(), _createBlock(_component_result_list_tickets_daily, {
              key: 1,
              tickets: _ctx.tickets
            }, null, 8, ["tickets"]))
          : (_openBlock(), _createBlock(_component_feedback_message, {
              key: 2,
              message: _ctx.$t('views.dailyReport.noEntry')
            }, null, 8, ["message"]))
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}